import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiMenu, FiX } from 'react-icons/fi';
import { CATEGORIES } from '../data/catalog';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // The three shelves get their own entries so a visitor can go straight to the
  // one they came for. They are sections of /products, hence the hash.
  const navLinks = [
    ...CATEGORIES.map((cat) => ({ name: cat.name, path: `/products#${cat.id}` })),
    { name: 'Support', path: '/support' },
  ];

  const current = location.pathname + location.hash;
  const isActive = (path) => current === path;

  return (
    <nav className="fixed w-full z-50 glass-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className="group flex items-center gap-2.5">
              {/* The shipped mark, not an icon-font stand-in. */}
              <img src="/favicon.svg" alt="" width="28" height="28" className="h-7 w-7" />
              <span className="font-display text-lg font-bold tracking-tight text-white transition-colors group-hover:text-ember-bright">
                MediaVerse Labs
              </span>
            </Link>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`text-sm font-medium transition-colors ${
                  isActive(link.path) ? 'text-white' : 'text-muted hover:text-white'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Mobile menu button */}
          <div className="flex md:hidden items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-muted hover:text-white p-2"
              aria-label={isOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={isOpen}
            >
              <SafeIcon icon={isOpen ? FiX : FiMenu} className="w-6 h-6" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && (
        <div className="md:hidden bg-card border-b border-border absolute w-full">
          <div className="px-4 pt-2 pb-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-medium ${
                  isActive(link.path)
                    ? 'bg-background text-white'
                    : 'text-muted hover:bg-background hover:text-white'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
